export const DownloadDialogController = ($scope,
                                         $mdDialog,
                                         callback) => {
    "ngInject";
    $scope.callback = callback;
    $scope.downloadObj = {
        captureModes: {
            photo: true,
            gif: true,
            boomerang: true,
            video: true
        },
        conditions: {
            dataPrivacyPopupAccepted: false,
            consentScreenConfirmed: false,
            dataFormWasSigned: false,
            checkboxConditions: [
                {
                    position: 1,
                    checked: false
                },
                {
                    position: 2,
                    checked: false
                },
                {
                    position: 3,
                    checked: false
                },
                {
                    position: 4,
                    checked: false
                },
                {
                    position: 5,
                    checked: false
                }
            ]
        }
    };

    $scope.closeDialog = () => {
        document.onkeypress = () => {};
        $mdDialog.hide();
    };

    $scope.create = () => {
        callback($scope.downloadObj);
        document.onkeypress = () => {};
        $mdDialog.hide();
    };

    $scope.checkOptions = (option) => {
        if (option === "photo") {
            if (!$scope.downloadObj.captureModes.gif && !$scope.downloadObj.captureModes.boomerang && !$scope.downloadObj.captureModes.video) {
                $scope.downloadObj.captureModes.photo = true;
            }
        }

        if (option === "gif") {
            if (!$scope.downloadObj.captureModes.photo && !$scope.downloadObj.captureModes.boomerang && !$scope.downloadObj.captureModes.video) {
                $scope.downloadObj.captureModes.gif = true;
            }
        }

        if (option === "boomerang") {
            if (!$scope.downloadObj.captureModes.gif && !$scope.downloadObj.captureModes.photo && !$scope.downloadObj.captureModes.video) {
                $scope.downloadObj.captureModes.boomerang = true;
            }
        }

        if (option === "video") {
            if (!$scope.downloadObj.captureModes.gif && !$scope.downloadObj.captureModes.photo && !$scope.downloadObj.captureModes.boomerang) {
                $scope.downloadObj.captureModes.video = true;
            }
        }
    };

    document.onkeypress = (ev) => {
        if (ev.key === "Enter") {
            $scope.create();
        }
    };
};



// WEBPACK FOOTER //
// ./sources/components/analytics/download-dialog/download-dialog.js